export const CERTIFICATE_PROFICIENCY_SYSCODE = {
  Reserved: 0,
  Completion: 1,
  Achievement: 2,
}

export const CertificateProficiencySyscodeString = {
  [CERTIFICATE_PROFICIENCY_SYSCODE.Reserved]: "Reserved",
  [CERTIFICATE_PROFICIENCY_SYSCODE.Completion]: "Certification of Completion",
  [CERTIFICATE_PROFICIENCY_SYSCODE.Achievement]: "Certification of Achievement",
};